import { useState, useEffect, useRef } from "react"
import "./components/Card";
import { Button } from "./components/Button"
import { Badge } from "./components/Badge"
import { Textarea } from "./components/TextArea"
import { Label } from "./components/Label"
import { Input } from "./components/Input"
import services from "../../API";
import { useDispatch, useSelector } from "react-redux"
import { openExtraCreditsModal } from "../../Store/uiSlice"
import CreateAudienceModal from "../Ads/CreateAudienceModal"
import { Plus, Clock, Minus, X, Megaphone, Video, ChevronDown } from "lucide-react";
import { AspectRatioIcon, getIconComponent, contentTypes } from "../Ads/GenerateContentModal"
import axios from "axios"
import TimePicker from "./components/TimePicker"
export function convertTo12Hour(time24) {
    // time24 should be in "HH:MM" format
    const [hourStr, minute] = time24.split(":");
    let hour = parseInt(hourStr, 10);
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12; // convert 0 -> 12, 13 -> 1, etc.
    return `${hour}:${minute} ${ampm}`;
}

const scheduleOptions = [
    { id: "Daily", label: "Daily", description: "Generate content every day" },
    { id: "Every_Other_Day", label: "Every Other Day", description: "Generate content every 2 days" },
    { id: "Twice_Weekly", label: "Twice Weekly", description: "Generate content twice per week" },
    { id: "Weekly", label: "Weekly", description: "Generate content once per week" },
    { id: "Custom_Schedule", label: "Custom Schedule", description: "Set your own schedule" },
]

const aspectRatios = [
    { id: "1:1", value: "1:1", label: "Square (1:1)" },
    { id: "9:16", value: "9:16", label: "Vertical (9:16)" },
    { id: "16:9", value: "16:9", label: "Wide (16:9)" },
    { id: "4:5", value: "4:5", label: "Portrait (4:5)" },
];

const CreateCampaignModal = ({
    open,
    onOpenChange,
    onCampaignCreated,
    prefilledData,
    selectedBrandValue
}) => {
    const isSimplifiedFlow = !!prefilledData

    const brands = useSelector((state) => state.data.apiData.brands?.data || []);
    const dispatch = useDispatch();
    const [isCreating, setIsCreating] = useState(false)
    const [editingAudience, setEditingAudience] = useState(null);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [, setStep] = useState(1);

    const [campaignName, setCampaignName] = useState("")
    const [campaignDescription, setCampaignDescription] = useState("")
    const contentTypeOptions = [
        {
            id: "image-ads",
            label: "Image Ads",
            description: "Scheduled social media advertisements and promotional content",
            icon: Megaphone,
        },
        {
            id: "videos",
            label: "Videos",
            description: "Scheduled video content and video advertisements",
            icon: Video,
            disabled: true,
        },
    ];

    const [selectedContentType, setSelectedContentType] = useState("image-ads")
    const [selectedAudience, setSelectedAudience] = useState("")
    const [selectedBrand, setSelectedBrand] = useState(selectedBrandValue || "")
    const [prompt, setPrompt] = useState("")
    const [contentCount, setContentCount] = useState(1)
    const [, setReferenceImage] = useState(null)

    const [scheduleType, setScheduleType] = useState("")
    const [scheduleTime, setScheduleTime] = useState("09:00")
    const [customDays, setCustomDays] = useState([])
    const [deliveryEmail, ] = useState(JSON.parse(localStorage?.getItem("userData"))?.email)

    // const [showCustomAudienceModal, setShowCustomAudienceModal] = useState(false)
    useState([]);
    const [brandSearchTerm, setBrandSearchTerm] = useState("");
    const [showBrandDropdown, setShowBrandDropdown] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [selectedSize, setSelectedSize] = useState("1:1");
    const [audiences, setAudiences] = useState([]);
    const dropdownRef = useRef(null);

    const handleAspectRatioChange = (ratio) => {
        setSelectedSize(ratio);
        setIsDropdownOpen(false);
    };

    useEffect(() => {
        if (selectedBrandValue) {
            setSelectedBrand(selectedBrandValue);
        }
    }, [selectedBrandValue]);
    // Filter brands based on search term
    const filteredBrands = brands.filter(
        (brand) =>
            brand.internalName
                ?.toLowerCase()
                .includes(brandSearchTerm?.toLowerCase()) ||
            brand?.description
                ?.toLowerCase()
                ?.includes(brandSearchTerm?.toLowerCase()) ||
            brand?.industry?.toLowerCase()?.includes(brandSearchTerm?.toLowerCase())
    );

    const handleBrandSelect = async (brand) => {
        setSelectedBrand(brand);
        setShowBrandDropdown(false);
    }

    const fetchBrands = () => {
        try {
            services.getBrands()
        } catch (error) {
            console.error(error);
        }
    }
    useEffect(() => {
        fetchBrands();
    }, [])

    useEffect(() => {
        if (!open) {
            setCampaignName("")
            setCampaignDescription("")
            setSelectedContentType("image-ads")
            setSelectedAudience("")
            setPrompt("")
            setContentCount(1)
            setSelectedSize("1:1")
            setReferenceImage(null)
            setScheduleType("")
            setScheduleTime("09:00")
            setCustomDays([])
            setIsCreating(false)
        }
    }, [open,])

    useEffect(() => {
        if (open && prefilledData) {
            if (prefilledData.contentType) setSelectedContentType(prefilledData.contentType)
            if (prefilledData.audienceId) setSelectedAudience(prefilledData.audienceId)
            if (prefilledData.brandId) setSelectedBrand(prefilledData.brandId)
            if (prefilledData.prompt) setPrompt(prefilledData.prompt)
            if (prefilledData.quantity) setContentCount(prefilledData.quantity)
            if (prefilledData.size) setSelectedSize(prefilledData.size)
            if (prefilledData.referenceImage) setReferenceImage(prefilledData.referenceImage)

            if (prefilledData.contentType && prefilledData.brandName) {
                const contentTypeName = contentTypes.find((t) => t.id === prefilledData.contentType)?.title || "Content"
                setCampaignName(`Daily ${prefilledData.brandName} ${contentTypeName}`)
            }
        }
    }, [open, prefilledData])

    const handleCreateCampaign = async () => {
        setIsCreating(true)
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const campaign = {
            name: campaignName,
            description: campaignDescription,
            email: deliveryEmail,
            brandID: selectedBrand,
            // contentType: selectedContentType,
            contentType: "Ads",
            deliveryTime: scheduleTime,
            timezone,
            scheduleAt: scheduleType,
            selectedDays: customDays,
            contentSize: selectedSize,
            contentQuantity: contentCount,
            contentPrompt: prompt,
        };

        if (selectedAudience) {
            campaign.audienceID = selectedAudience;
        }
        try {

            await services.createCampaign(campaign)
            onCampaignCreated(prev => !prev)
            // setIsCreating(false)
            // if (onCampaignCreated) onCampaignCreated(campaign)
            onOpenChange(false)
        } catch (error) {
            setIsCreating(false)
            console.error(error);
            if (error.response?.data?.code === "INSUFFICIENT_CREDITS") {
                dispatch(openExtraCreditsModal());
            }
        }
    }


    useEffect(() => {
        const token = localStorage.getItem("token");
        const fetchAudiences = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API}audiences`,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
                setAudiences(response.data.data);
            } catch (err) {
                setAudiences([]);
            }
        };
        fetchAudiences();
    }, [showCreateModal]);


    const canCreateCampaign = campaignName.trim() !== "" &&
        deliveryEmail.trim() !== "" &&
        // selectedContentType !== "" &&
        // selectedAudience !== "" &&
        scheduleType !== ""


    const handleSaveAudience = (audienceData) => {
        if (editingAudience) {
            // Update existing audience
            setAudiences((prev) =>
                prev.map((audience) =>
                    audience.id === editingAudience.id
                        ? { ...audienceData, id: editingAudience.id }
                        : audience
                )
            );
            setEditingAudience(null);
        } else {
            // Create new audience
            setAudiences((prev) => [
                ...prev,
                {
                    ...audienceData,
                    createdAt: new Date().toISOString().split("T")[0],
                    usageCount: 0,
                },
            ]);
        }
        setShowCreateModal(false);
    };

    return (
        <>
            {open && (
                <div
                    className="automation-modal-overlay fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[9999] p-4"
                    onClick={() => onOpenChange(false)}
                >
                    <div
                        className="automation-modal w-full max-w-4xl bg-white dark:bg-[#111111] rounded-3xl shadow-2xl max-h-[90vh] flex flex-col"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Modal Header */}
                        <div className="p-6 border-b border-gray-200 dark:border-white/10 flex-shrink-0">
                            <div className="flex items-start justify-between">
                                <div>
                                    <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">
                                        {isSimplifiedFlow ? "Schedule Your Content" : "Create Scheduled Campaign"}
                                    </h2>
                                    <p className="text-sm mt-1 text-gray-600 dark:text-gray-400">
                                        {isSimplifiedFlow
                                            ? "Set up automated delivery for your selected content"
                                            : "Set up automated content generation with custom scheduling"}
                                    </p>
                                </div>
                                <button
                                    onClick={() => onOpenChange(false)}
                                    className="p-2 rounded-xl transition-colors text-gray-600 hover:text-gray-900 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-white dark:hover:bg-white/5"
                                >
                                    <X className="h-5 w-5" />
                                </button>
                            </div>
                        </div>

                        {/* Body - Scrollable Content */}
                        <div className="automation-modal-body flex-1 overflow-y-auto p-6 space-y-8">
                            {/* Campaign Details Section */}
                            <div className="space-y-6">
                                <div className="text-center">
                                    <h3 className="text-xl font-bold text-gray-900 dark:text-[#fff] mb-2">Campaign Details</h3>
                                    <p className="text-gray-600 dark:text-gray-400">Set up your campaign name and email delivery settings</p>
                                </div>

                                <div className="mb-6 p-4 rounded-xl border bg-orange-50 border-orange-200 dark:bg-orange-500/10 dark:border-orange-500/30">
                                    <div className="automation-brand-row flex items-center justify-between">
                                        <div className="flex items-center gap-2">
                                            <span className="text-xs font-semibold uppercase tracking-wide text-orange-600 dark:text-orange-400">
                                                Brand Selected
                                            </span>
                                            <span className="text-sm text-gray-700 dark:text-gray-300">
                                                Campaign will be generated for:
                                            </span>
                                        </div>

                                        <div className="automation-brand-select relative" ref={dropdownRef}>
                                            <div className="relative">
                                                <button
                                                    className="gap-2 px-3 py-1.5 rounded-md border border-gray-300 dark:border-white/10 bg-white dark:bg-white/5 text-gray-900 dark:text-white hover:bg-gray-50 dark:hover:bg-white/10 text-sm font-medium inline-flex items-center justify-between w-64"
                                                    onClick={() => setShowBrandDropdown(!showBrandDropdown)}
                                                >
                                                    <span className="truncate w-full text-left">
                                                        {filteredBrands?.find((brand) => brand._id === selectedBrand)?.internalName || "Select a brand"}
                                                    </span>
                                                    <ChevronDown className="h-4 w-4 shrink-0" />
                                                </button>

                                                {showBrandDropdown && (
                                                    <div className="absolute top-full left-0 right-0 mt-1 rounded-md border border-gray-200 dark:border-white/10 bg-white dark:bg-[#111111] shadow-xl z-50 max-h-[400px] flex flex-col">
                                                        <div className="p-3 border-b border-gray-200 dark:border-white/10">
                                                            <div className="relative">
                                                                <svg
                                                                    className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4"
                                                                    fill="none"
                                                                    stroke="currentColor"
                                                                    viewBox="0 0 24 24"
                                                                >
                                                                    <path
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                        strokeWidth={2}
                                                                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                                                    />
                                                                </svg>
                                                                <input
                                                                    placeholder="Search brands..."
                                                                    value={brandSearchTerm}
                                                                    onChange={(e) => setBrandSearchTerm(e.target.value)}
                                                                    className="pl-10 h-9 border border-gray-300 dark:border-white/10 bg-white dark:bg-[#111111] text-gray-900 dark:text-white rounded text-sm placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-orange-500 w-full"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="flex-1 overflow-y-auto p-1 flex flex-col min-h-0">
                                                            {filteredBrands.length > 0 ? (
                                                                filteredBrands.map((brand, index) => (
                                                                    <button
                                                                        key={index}
                                                                        onClick={() => handleBrandSelect(brand._id)}
                                                                        className="w-full px-4 py-2.5 text-left flex items-center gap-2 text-sm text-gray-900 dark:text-white hover:bg-gray-100 dark:hover:bg-white/5"
                                                                    >
                                                                        {selectedBrand === brand._id ? (
                                                                            <span className="text-orange-500">✓</span>
                                                                        ) : (
                                                                            <span className="w-4"></span>
                                                                        )}
                                                                        <span>{brand.brandName}</span>
                                                                    </button>
                                                                ))
                                                            ) : (
                                                                <div className="px-4 py-6 text-center text-gray-400 dark:text-gray-500">
                                                                    <div className="text-sm">No brands found</div>
                                                                    <div className="text-xs">
                                                                        Try adjusting your search
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="max-w-2xl mx-auto space-y-4">
                                    <div className="space-y-2">
                                        <Label htmlFor="campaign-name" className="text-gray-700 dark:text-gray-300">Campaign Name *</Label>
                                        <Input
                                            id="campaign-name"
                                            className="w-full bg-white dark:bg-white/5 text-gray-900 dark:text-white border-gray-200 dark:border-white/10"
                                            placeholder="e.g., Daily TechFlow Ads"
                                            value={campaignName}
                                            onChange={(e) => setCampaignName(e.target.value)}
                                        />
                                    </div>

                                    <div className="space-y-2">
                                        <Label htmlFor="campaign-description" className="text-gray-700 dark:text-gray-300">Description (Optional)</Label>
                                        <Textarea
                                            id="campaign-description"
                                            placeholder={
                                                isSimplifiedFlow
                                                    ? "Add any additional notes for this automated campaign"
                                                    : "Brief description of this campaign's purpose"
                                            }
                                            value={campaignDescription}
                                            onChange={(e) => setCampaignDescription(e.target.value)}
                                            className="min-h-[80px] px-2 py-1 bg-white dark:bg-white/5 text-gray-900 dark:text-white border-gray-200 dark:border-white/10"
                                        />
                                    </div>

                                    <div className="space-y-2">
                                        <Label htmlFor="delivery-email" className="text-gray-700 dark:text-gray-300">Email Address for Content Delivery *</Label>
                                        <Input
                                            id="delivery-email"
                                            type="email"
                                            className="w-full bg-gray-50 dark:bg-white/[0.02] text-gray-500 dark:text-gray-400 border-gray-200 dark:border-white/10"
                                            disabled
                                            placeholder="your@email.com"
                                            value={deliveryEmail}
                                        />
                                        <p className="text-sm text-gray-500 dark:text-gray-400">
                                            Generated content will be sent to this email address according to your schedule
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Content Type Selection Section */}
                            {!isSimplifiedFlow && (
                                <div className="space-y-4">
                                    <div className="text-center">
                                        <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">What content do you want to generate?</h3>
                                        <p className="text-gray-600 dark:text-gray-400">Choose the type of content for your scheduled campaign</p>
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 max-w-4xl mx-auto">
                                        {contentTypeOptions.map((option) => (
                                            <button
                                                key={option.id}
                                                onClick={() => !option.disabled && setSelectedContentType(option.id)}
                                                disabled={option.disabled}
                                                className={`p-4 rounded-xl border-2 text-left transition-all ${option.disabled
                                                    ? "border-gray-100 bg-gray-50 dark:border-white/5 dark:bg-white/[0.02] cursor-not-allowed opacity-50"
                                                    : selectedContentType === option.id
                                                        ? "border-orange-500 bg-orange-50 dark:bg-orange-500/10"
                                                        : "border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50 dark:border-white/10 dark:bg-white/5 dark:hover:border-white/20 dark:hover:bg-white/10"
                                                    }`}
                                            >
                                                <div className="flex items-start gap-3">
                                                    <div
                                                        className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${selectedContentType === option.id
                                                            ? "bg-orange-500 text-white"
                                                            : "bg-gray-100 text-gray-600 dark:bg-white/10 dark:text-gray-400"
                                                            }`}
                                                    >
                                                        <option.icon className="h-5 w-5" />
                                                    </div>
                                                    <div className="flex-1 min-w-0">
                                                        <div className="font-semibold mb-1 text-gray-900 dark:text-white text-sm">
                                                            {option.label}
                                                        </div>
                                                        <div className="text-xs text-gray-600 dark:text-gray-400">
                                                            {option.description}
                                                        </div>
                                                    </div>
                                                </div>
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            )}



                            <div className="space-y-4">
                                <div className="text-center">
                                    <h3 className="text-xl font-bold text-gray-900 dark:text-[#fff] mb-2">
                                        Who is your target audience? (Optional)
                                    </h3>
                                    <p className="text-gray-600 dark:text-gray-400">
                                        Selecting an audience helps create more targeted content, or
                                        skip to use your brand's default audience
                                    </p>
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                    {/* Add Custom Audience Card - First */}
                                    <div
                                        className="p-4 cursor-pointer transition-all border-2 border-dashed border-gray-300 dark:border-gray-600 hover:border-orange-300 dark:hover:border-orange-500 hover:bg-orange-50 dark:hover:bg-orange-900/20 rounded-lg"
                                        onClick={() => {
                                            setEditingAudience(null);
                                            setShowCreateModal(true);
                                        }}
                                    >
                                        <div className="space-y-3 text-center">
                                            <div className="w-8 h-8 mx-auto rounded-lg bg-gray-100 dark:bg-gray-700 flex items-center justify-center">
                                                {getIconComponent("Plus")}
                                            </div>
                                            <div>
                                                <h4 className="font-semibold text-gray-900 dark:text-[#fff] text-sm">
                                                    Create New Audience
                                                </h4>
                                                <p className="text-xs text-gray-600 dark:text-gray-400 mt-1">
                                                    Define your own target audience
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* API Audiences */}
                                    {audiences.length === 0 && (
                                        <div className="col-span-full text-center text-gray-400 dark:text-gray-500 py-8">
                                            No audiences found.
                                        </div>
                                    )}
                                    {audiences.map((audience) => (
                                        <div
                                            key={audience._id}
                                            className={`p-4 cursor-pointer transition-all border-2 rounded-lg ${selectedAudience === audience._id
                                                ? "border-orange-500 bg-orange-50 dark:bg-orange-900/20"
                                                : "border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800"
                                                }`}
                                            onClick={() => {
                                                setSelectedAudience(audience._id);
                                                setStep(3);
                                            }}
                                        >
                                            <div className="space-y-3">
                                                <div className="flex items-start space-x-3">
                                                    <div
                                                        className={`w-8 h-8 rounded-lg flex items-center justify-center ${selectedAudience === audience._id
                                                            ? "bg-orange-500 text-white"
                                                            : "bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400"
                                                            }`}
                                                    >
                                                        {getIconComponent(audience.icon || "Users")}
                                                    </div>
                                                    <div className="flex-1">
                                                        <div className="flex items-center gap-2">
                                                            <h4 className="font-semibold text-gray-900 dark:text-[#fff] text-sm">
                                                                {audience.name || audience.title}
                                                            </h4>
                                                            {audience.isCustom && (
                                                                <span className="border border-gray-300 dark:border-gray-600 px-1.5 py-0.5 rounded text-xs text-gray-700 dark:text-gray-300">
                                                                    Custom
                                                                </span>
                                                            )}
                                                        </div>
                                                        <p className="text-xs text-gray-600 dark:text-gray-400 mt-1">
                                                            {audience.description}
                                                        </p>
                                                    </div>
                                                </div>
                                                {audience.demographics && (
                                                    <div className="pt-2 border-t border-gray-100 dark:border-gray-700">
                                                        <span className="bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 px-2 py-1 rounded text-xs">
                                                            {audience.demographics}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            {/* Schedule Configuration Section */}
                            <div className="space-y-6">
                                <div className="text-center">
                                    <h3 className="text-xl font-bold text-gray-900 dark:text-[#fff] mb-2">Set Your Schedule</h3>
                                    <p className="text-gray-600 dark:text-gray-400">Choose how often you want to receive generated content</p>
                                </div>

                                <div className="max-w-3xl mx-auto space-y-6">
                                    {/* Schedule Type Selection */}

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        {scheduleOptions.map((option) => (
                                            <div
                                                key={option.id}
                                                className={`p-4 cursor-pointer rounded-2xl transition-all border-2 ${scheduleType === option.id
                                                    ? "border-orange-500 bg-orange-50 dark:bg-orange-900/20"
                                                    : "border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800"
                                                    }`}
                                                onClick={() => setScheduleType(option.id)}
                                            >
                                                <div className="flex items-start space-x-3">
                                                    <div
                                                        className={`w-8 h-8 rounded-lg flex items-center justify-center ${scheduleType === option.id
                                                            ? "bg-orange-500 text-white"
                                                            : "bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400"
                                                            }`}
                                                    >
                                                        <Clock className="w-4 h-4" />
                                                    </div>
                                                    <div>
                                                        <h4 className="font-semibold text-gray-900 dark:text-[#fff] text-sm">{option.label}</h4>
                                                        <p className="text-xs text-gray-600 dark:text-gray-400 mt-1">{option.description}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    {/* Schedule Time */}
                                    <div className="space-y-2">
                                        <Label htmlFor="schedule-time" className="text-gray-700 dark:text-gray-300">Delivery Time</Label>
                                        <div className="automation-schedule-time flex items-center space-x-2">

                                            <TimePicker
                                                value={scheduleTime}
                                                onChange={setScheduleTime}
                                                className="w-32" // Optional: custom width
                                            />
                                            <span className="text-sm text-gray-500 dark:text-gray-400">Content will be generated and sent at this time</span>
                                        </div>
                                    </div>

                                    {/* Custom Days Selection (for twice weekly and custom) */}

                                    {(scheduleType === "Twice_Weekly" || scheduleType === "Custom_Schedule") && (
                                        <div className="space-y-2">
                                            <Label className="text-gray-700 dark:text-gray-300">Select Days</Label>
                                            <div className="automation-days grid grid-cols-4 gap-2 sm:grid-cols-7">
                                                {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map((day) => (
                                                    <Button
                                                        key={day}
                                                        type="button"
                                                        variant={customDays.includes(day) ? "default" : "outline"}
                                                        size="sm"
                                                        aria-label={day}
                                                        onClick={() => {
                                                            if (customDays.includes(day)) {
                                                                // Deselect the day
                                                                setCustomDays(customDays.filter((d) => d !== day));
                                                            } else {
                                                                if (scheduleType === "Twice_Weekly" && customDays.length >= 2) {
                                                                    // Prevent selecting more than 2
                                                                    return;
                                                                }
                                                                setCustomDays([...customDays, day]);
                                                            }
                                                        }}
                                                        className={
                                                            customDays.includes(day)
                                                                ? "bg-orange-500 hover:bg-orange-600 text-white"
                                                                : "hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300 border-gray-300 dark:border-gray-600"
                                                        }
                                                    >
                                                        <span className="sm:hidden">{day.slice(0, 3)}</span><span className="hidden sm:inline">{day}</span>
                                                    </Button>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                </div>
                            </div>

                            {/* Content Parameters Section */}
                            {!isSimplifiedFlow && (
                                <div className="space-y-6">
                                    <div className="text-center">
                                        <h3 className="text-xl font-bold text-gray-900 dark:text-[#fff] mb-2">Content Parameters</h3>
                                        <p className="text-gray-600 dark:text-gray-400">Configure the content generation settings</p>
                                    </div>

                                    <div className="max-w-2xl mx-auto space-y-6">
                                        <div className="space-y-4">
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                <div className="space-y-2">
                                                    <Label htmlFor="content-count" className="text-gray-700 dark:text-gray-300">Content Quantity</Label>
                                                    <div className="flex items-center border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 w-32">
                                                        <button
                                                            type="button"
                                                            onClick={() => setContentCount(Math.max(1, contentCount - 1))}
                                                            className="p-2 hover:bg-gray-50 dark:hover:bg-gray-700 text-orange-600 dark:text-orange-400 rounded-l-lg"
                                                        >
                                                            <Minus className="w-4 h-4" />
                                                        </button>
                                                        <input
                                                            type="number"
                                                            value={contentCount}
                                                            onChange={(e) => setContentCount(Math.max(1, Number.parseInt(e.target.value) || 1))}
                                                            className="flex-1 text-center text-base font-medium border-0 focus:outline-none py-2 bg-white dark:bg-gray-800 text-gray-900 dark:text-[#fff] [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                                                            min="1"
                                                            max="10"
                                                        />
                                                        <button
                                                            type="button"
                                                            onClick={() => setContentCount(Math.min(10, contentCount + 1))}
                                                            className="p-2 hover:bg-gray-50 dark:hover:bg-gray-700 text-orange-600 dark:text-orange-400 rounded-r-lg"
                                                        >
                                                            <Plus className="w-4 h-4" />
                                                        </button>
                                                    </div>
                                                </div>

                                                <div className="space-y-2">
                                                    <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                                                        What size do you want?
                                                    </label>
                                                    <div className="relative">
                                                        <button
                                                            type="button"
                                                            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                                            className="w-full px-3 py-3 pr-10 border border-gray-300 dark:border-gray-600 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white dark:bg-gray-800 text-gray-900 dark:text-[#fff] text-left flex items-center gap-3"
                                                        >
                                                            <AspectRatioIcon ratio={selectedSize} />
                                                            <span>
                                                                {
                                                                    aspectRatios.find((r) => r.id === selectedSize)
                                                                        ?.label
                                                                }
                                                            </span>
                                                            <svg
                                                                className="w-4 h-4 text-gray-400 ml-auto"
                                                                fill="none"
                                                                stroke="currentColor"
                                                                viewBox="0 0 24 24"
                                                            >
                                                                <path
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                    strokeWidth={2}
                                                                    d="M19 9l-7 7-7-7"
                                                                />
                                                            </svg>
                                                        </button>

                                                        {isDropdownOpen && (
                                                            <div className="absolute top-full left-0 right-0 mt-1 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg shadow-lg z-10">
                                                                <div className="p-2">
                                                                    {aspectRatios.map((ratio) => (
                                                                        <button
                                                                            key={ratio.value}
                                                                            type="button"
                                                                            onClick={() => handleAspectRatioChange(ratio.id)}
                                                                            className="w-full px-3 py-2 text-left hover:bg-gray-50 dark:hover:bg-gray-700 rounded flex items-center gap-3 text-sm text-gray-900 dark:text-[#fff]"
                                                                        >
                                                                            <AspectRatioIcon ratio={ratio.id} />
                                                                            <span>{ratio.label}</span>
                                                                            {selectedSize === ratio.id && (
                                                                                <svg
                                                                                    className="w-4 h-4 text-green-500 ml-auto"
                                                                                    fill="none"
                                                                                    stroke="currentColor"
                                                                                    viewBox="0 0 24 24"
                                                                                >
                                                                                    <path
                                                                                        strokeLinecap="round"
                                                                                        strokeLinejoin="round"
                                                                                        strokeWidth={2}
                                                                                        d="M5 13l4 4L19 7"
                                                                                    />
                                                                                </svg>
                                                                            )}
                                                                        </button>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="space-y-2">
                                                <Label htmlFor="campaign-prompt" className="text-gray-700 dark:text-gray-300">Content Prompt (Optional)</Label>
                                                <Textarea
                                                    id="campaign-prompt"
                                                    placeholder="Add specific instructions for content generation (optional)"
                                                    value={prompt}
                                                    onChange={(e) => setPrompt(e.target.value)}
                                                    className="min-h-[80px] px-2 py-1 bg-white dark:bg-gray-800 text-gray-900 dark:text-[#fff] border-gray-300 dark:border-gray-600"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Campaign Summary Section */}
                            <div className="space-y-6">
                                <div className="text-center">
                                    <h3 className="text-xl font-bold text-gray-900 dark:text-[#fff] mb-2">Campaign Summary</h3>
                                    <p className="text-gray-600 dark:text-gray-400">Review your campaign settings before creating</p>
                                </div>

                                <div className="max-w-2xl mx-auto">
                                    <div className="bg-gray-50 dark:bg-white/5 border border-gray-100 dark:border-white/10 p-4 rounded-lg">
                                        <h4 className="font-medium text-gray-900 dark:text-[#fff] mb-3">Campaign Summary</h4>
                                        <div className="automation-summary space-y-2 text-sm">
                                            <div className="flex items-center justify-between">
                                                <span className="text-gray-600 dark:text-gray-400">Campaign Name:</span>
                                                <Badge variant="outline" className="text-gray-700 dark:text-gray-300 border-gray-300 dark:border-gray-600">{campaignName || "Untitled Campaign"}</Badge>
                                            </div>
                                            <div className="flex items-center justify-between">
                                                <span className="text-gray-600 dark:text-gray-400">Content Type:</span>
                                                <Badge variant="outline" className="text-gray-700 dark:text-gray-300 border-gray-300 dark:border-gray-600">Ads</Badge>
                                            </div>
                                            <div className="flex items-center justify-between">
                                                <span className="text-gray-600 dark:text-gray-400">Audience:</span>
                                                <Badge variant="outline" className="text-gray-700 dark:text-gray-300 border-gray-300 dark:border-gray-600">{audiences?.find((a) => a?._id === selectedAudience)?.name}</Badge>
                                            </div>
                                            <div className="flex items-center justify-between">
                                                <span className="text-gray-600 dark:text-gray-400">Schedule:</span>
                                                <Badge variant="outline" className="text-gray-700 dark:text-gray-300 border-gray-300 dark:border-gray-600">{scheduleOptions.find((s) => s.id === scheduleType)?.label}</Badge>
                                            </div>
                                            <div className="flex items-center justify-between">
                                                <span className="text-gray-600 dark:text-gray-400">Delivery Time:</span>
                                                <Badge variant="outline" className="text-gray-700 dark:text-gray-300 border-gray-300 dark:border-gray-600">{convertTo12Hour(scheduleTime)}</Badge>
                                            </div>
                                            <div className="flex items-center justify-between">
                                                <span className="text-gray-600 dark:text-gray-400">Email:</span>
                                                <Badge variant="outline" className="text-gray-700 dark:text-gray-300 border-gray-300 dark:border-gray-600">{deliveryEmail}</Badge>
                                            </div>
                                            <div className="flex items-center justify-between">
                                                <span className="text-gray-600 dark:text-gray-400">Content per delivery:</span>
                                                <Badge variant="outline" className="text-gray-700 dark:text-gray-300 border-gray-300 dark:border-gray-600">
                                                    {contentCount} {aspectRatios.find((s) => s.id === selectedSize)?.label}
                                                </Badge>
                                            </div>
                                            {prompt && (
                                                <div className="flex items-start justify-between">
                                                    <span className="text-gray-600 dark:text-gray-400">Custom Prompt:</span>
                                                    <div className="text-right max-w-xs">
                                                        <Badge variant="outline" className="text-xs text-gray-700 dark:text-gray-300 border-gray-300 dark:border-gray-600">
                                                            {prompt.substring(0, 50)}
                                                            {prompt.length > 50 ? "..." : ""}
                                                        </Badge>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Action Buttons */}
                            <div className="automation-modal-actions p-6 border-t border-gray-200 dark:border-white/10 flex items-center justify-between flex-shrink-0 bg-white dark:bg-[#111111] rounded-b-3xl">
                                <button
                                    onClick={() => onOpenChange(false)}
                                    disabled={isCreating}
                                    className="px-6 py-2.5 rounded-xl border border-gray-200 dark:border-white/10 text-gray-600 dark:text-gray-400 font-medium hover:bg-gray-50 dark:hover:bg-white/5 transition-colors"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleCreateCampaign}
                                    disabled={isCreating || !canCreateCampaign}
                                    className="px-8 py-2.5 rounded-xl bg-orange-500 hover:bg-orange-600 disabled:opacity-50 disabled:cursor-not-allowed text-white font-semibold transition-all shadow-lg shadow-orange-500/25 flex items-center gap-2"
                                >
                                    {isCreating ? "Creating Campaign..." : "Create Campaign"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <CreateAudienceModal
                open={showCreateModal}
                onOpenChange={setShowCreateModal}
                onSave={handleSaveAudience}
                editingAudience={editingAudience}
            />
        </>
    )
}

export default CreateCampaignModal
